import { createContext } from 'react';
import { IReminderContext } from './models/IReminderContext.ts';
import { IReminder } from '../interfaces/account/reminder/IReminder.ts';

export const ReminderContext = createContext<IReminderContext>({
    isVisible: false,
    reminder: null,
    addReminder: (newReminder: IReminder) => {newReminder;
    },
    closeReminder: () => {
    },
});